import Axios from "axios";
import { GET_BRANDS_URL, GET_BRAND_ITEMS_URL } from "../../configs";
import {
  GET_BRANDS,
  GET_BRANDS_LOADING,
  GET_FEATURED_BRANDS,
  GET_FEATURED_BRANDS_LOADING,
  GET_BRAND_ITEMS,
  GET_BRAND_ITEMS_LOADING,
  RESET_BRAND_ITEMS,
} from "./actionTypes";

/**
 * Fetch brands.
 * @param {Object} [options]
 * @param {boolean} [options.featured] - only featured brands (home strip)
 * @param {number} [options.limit] - max results (e.g. 4 for home)
 */
export const getBrands = (options = {}) => (dispatch) => {
  const featured = !!(options && options.featured);
  const limit = options && options.limit != null ? options.limit : null;

  const params = {};
  if (featured) params.featured = 1;
  if (limit != null && limit !== "") params.limit = limit;

  const loadingType = featured ? GET_FEATURED_BRANDS_LOADING : GET_BRANDS_LOADING;
  const successType = featured ? GET_FEATURED_BRANDS : GET_BRANDS;

  dispatch({ type: loadingType, payload: true });
  return Axios.get(GET_BRANDS_URL, { params })
    .then((response) => {
      const brands =
        (response.data && response.data.brands) ? response.data.brands : [];
      dispatch({ type: successType, payload: brands });
      dispatch({ type: loadingType, payload: false });
      return brands;
    })
    .catch(() => {
      dispatch({ type: successType, payload: [] });
      dispatch({ type: loadingType, payload: false });
      return [];
    });
};

// Fetch all products of a brand (across the whole catalog).
export const getBrandItems = (brandId) => (dispatch) => {
  dispatch({ type: GET_BRAND_ITEMS_LOADING, payload: true });
  return Axios.get(`${GET_BRAND_ITEMS_URL}/${brandId}`)
    .then((response) => {
      const data = response.data || {};
      dispatch({
        type: GET_BRAND_ITEMS,
        payload: {
          brand: data.brand || null,
          items: Array.isArray(data.items) ? data.items : [],
        },
      });
      dispatch({ type: GET_BRAND_ITEMS_LOADING, payload: false });
      return data;
    })
    .catch(() => {
      dispatch({
        type: GET_BRAND_ITEMS,
        payload: { brand: null, items: [] },
      });
      dispatch({ type: GET_BRAND_ITEMS_LOADING, payload: false });
      return null;
    });
};

export const resetBrandItems = () => (dispatch) => {
  dispatch({ type: RESET_BRAND_ITEMS });
};
